module.exports = __webpack_public_path__ + "img/bus-gray.dca93a32.svg";